// Personal Agenda Events Dataset

export const defaultVisibleDate = new Date('2025-07-01T00:00:00');

export const initialEvents = [
  // =====================
  // JULY 2025
  // =====================

  // Week of Jun 30 – Jul 6
  {
    id: 'w-1',
    start: '2025-06-30T09:30:00',
    end: '2025-06-30T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-1',
    start: '2025-06-30T07:00:00',
    end: '2025-06-30T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'h-2',
    start: '2025-07-01T18:00:00',
    end: '2025-07-01T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-2',
    start: '2025-07-02T10:00:00',
    end: '2025-07-02T11:00:00',
    title: '1-on-1 with Sarah',
    resource: 'work',
  },
  {
    id: 'h-3',
    start: '2025-07-02T07:00:00',
    end: '2025-07-02T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'f-1',
    start: '2025-07-03T00:00:00',
    end: '2025-07-04T00:00:00',
    title: "Alice's Birthday",
    resource: 'family',
    allDay: true,
    readOnly: true,
  },
  {
    id: 'w-3',
    start: '2025-07-03T14:00:00',
    end: '2025-07-03T15:30:00',
    title: 'Code Review',
    resource: 'work',
  },
  {
    id: 's-1',
    start: '2025-07-04T12:00:00',
    end: '2025-07-04T17:00:00',
    title: '4th of July BBQ',
    resource: 'social',
    readOnly: true,
  },
  {
    id: 'h-4',
    start: '2025-07-06T09:00:00',
    end: '2025-07-06T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Jul 7 – Jul 13
  {
    id: 'w-4',
    start: '2025-07-07T10:00:00',
    end: '2025-07-07T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'h-5',
    start: '2025-07-07T07:00:00',
    end: '2025-07-07T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-5',
    start: '2025-07-08T15:00:00',
    end: '2025-07-08T16:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'w-6',
    start: '2025-07-09T14:00:00',
    end: '2025-07-09T16:00:00',
    title: 'Design Review',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 'h-6',
    start: '2025-07-10T18:00:00',
    end: '2025-07-10T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 's-2',
    start: '2025-07-11T17:30:00',
    end: '2025-07-11T19:30:00',
    title: 'Happy Hour',
    resource: 'social',
  },
  {
    id: 'p-1',
    start: '2025-07-12T11:00:00',
    end: '2025-07-12T12:00:00',
    title: 'Haircut',
    resource: 'personal',
  },
  // Week of Jul 14 – Jul 20
  {
    id: 'w-7',
    start: '2025-07-14T09:30:00',
    end: '2025-07-14T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'w-8',
    start: '2025-07-15T10:00:00',
    end: '2025-07-15T11:00:00',
    title: '1-on-1 with James',
    resource: 'work',
  },
  {
    id: 'h-7',
    start: '2025-07-15T07:00:00',
    end: '2025-07-15T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 's-3',
    start: '2025-07-16T12:00:00',
    end: '2025-07-16T13:00:00',
    title: 'Lunch with Colleague',
    resource: 'social',
  },
  {
    id: 'h-8',
    start: '2025-07-17T15:00:00',
    end: '2025-07-17T16:00:00',
    title: 'Dentist',
    resource: 'health',
  },
  {
    id: 'w-9',
    start: '2025-07-18T11:00:00',
    end: '2025-07-18T11:45:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 's-4',
    start: '2025-07-19T19:30:00',
    end: '2025-07-19T22:00:00',
    title: 'Dinner with Friends',
    resource: 'social',
    readOnly: true,
  },
  // Week of Jul 21 – Jul 27
  {
    id: 'h-9',
    start: '2025-07-21T07:00:00',
    end: '2025-07-21T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-10',
    start: '2025-07-21T15:00:00',
    end: '2025-07-21T16:00:00',
    title: 'All-hands Meeting',
    resource: 'work',
  },
  {
    id: 'h-10',
    start: '2025-07-22T18:00:00',
    end: '2025-07-22T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-11',
    start: '2025-07-23T10:00:00',
    end: '2025-07-23T12:00:00',
    title: 'Roadmap Planning',
    resource: 'work',
  },
  {
    id: 'w-12',
    start: '2025-07-24T14:00:00',
    end: '2025-07-24T14:45:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 's-5',
    start: '2025-07-26T19:00:00',
    end: '2025-07-26T23:00:00',
    title: 'Game Night',
    resource: 'social',
  },
  {
    id: 'p-2',
    start: '2025-07-26T10:00:00',
    end: '2025-07-26T11:30:00',
    title: 'Grocery Shopping',
    resource: 'personal',
  },
  {
    id: 'f-2',
    start: '2025-07-27T11:00:00',
    end: '2025-07-27T13:00:00',
    title: 'Brunch with Parents',
    resource: 'family',
  },
  // Week of Jul 28 – Jul 31
  {
    id: 'w-13',
    start: '2025-07-28T09:30:00',
    end: '2025-07-28T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-11',
    start: '2025-07-28T07:00:00',
    end: '2025-07-28T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-14',
    start: '2025-07-29T14:00:00',
    end: '2025-07-29T15:00:00',
    title: 'Performance Review',
    resource: 'work',
  },
  {
    id: 's-6',
    start: '2025-07-30T20:00:00',
    end: '2025-07-30T22:30:00',
    title: 'Movie Night',
    resource: 'social',
  },
  {
    id: 'h-12',
    start: '2025-07-31T18:00:00',
    end: '2025-07-31T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  // =====================
  // AUGUST 2025
  // =====================

  // Week of Aug 1 – Aug 3
  {
    id: 'w-15',
    start: '2025-08-01T10:00:00',
    end: '2025-08-01T10:30:00',
    title: 'Wrap-up Meeting',
    resource: 'work',
  },
  {
    id: 'p-3',
    start: '2025-08-02T14:00:00',
    end: '2025-08-02T16:00:00',
    title: 'Packing for Vacation',
    resource: 'personal',
  },
  // Week of Aug 4 – Aug 10 — Beach vacation
  {
    id: 't-1',
    start: '2025-08-04T00:00:00',
    end: '2025-08-11T00:00:00',
    title: 'Beach Vacation',
    resource: 'travel',
    allDay: true,
  },
  // Week of Aug 11 – Aug 17
  {
    id: 'w-16',
    start: '2025-08-11T09:30:00',
    end: '2025-08-11T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-13',
    start: '2025-08-11T07:00:00',
    end: '2025-08-11T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-17',
    start: '2025-08-13T10:00:00',
    end: '2025-08-13T11:00:00',
    title: '1-on-1 with Sarah',
    resource: 'work',
  },
  {
    id: 'h-14',
    start: '2025-08-14T18:00:00',
    end: '2025-08-14T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 's-7',
    start: '2025-08-16T19:30:00',
    end: '2025-08-16T21:30:00',
    title: 'Dinner with Friends',
    resource: 'social',
    readOnly: true,
  },
  // Week of Aug 18 – Aug 24
  {
    id: 'w-18',
    start: '2025-08-18T10:00:00',
    end: '2025-08-18T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'w-19',
    start: '2025-08-19T14:00:00',
    end: '2025-08-19T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'h-15',
    start: '2025-08-20T07:00:00',
    end: '2025-08-20T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'h-16',
    start: '2025-08-21T17:00:00',
    end: '2025-08-21T18:00:00',
    title: 'Swimming',
    resource: 'health',
  },
  {
    id: 'f-3',
    start: '2025-08-24T18:00:00',
    end: '2025-08-24T20:00:00',
    title: 'Family Dinner',
    resource: 'family',
  },
  // Week of Aug 25 – Aug 31
  {
    id: 'w-20',
    start: '2025-08-25T09:30:00',
    end: '2025-08-25T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-17',
    start: '2025-08-25T07:00:00',
    end: '2025-08-25T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-21',
    start: '2025-08-27T14:00:00',
    end: '2025-08-27T16:00:00',
    title: 'Design Review',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 'f-4',
    start: '2025-08-29T00:00:00',
    end: '2025-08-30T00:00:00',
    title: "Bob's Birthday",
    resource: 'family',
    allDay: true,
    readOnly: true,
  },
  {
    id: 's-8',
    start: '2025-08-30T15:00:00',
    end: '2025-08-30T19:00:00',
    title: "BBQ at Mike's",
    resource: 'social',
    readOnly: true,
  },
  // =====================
  // SEPTEMBER 2025
  // =====================

  // Week of Sep 1 – Sep 7
  {
    id: 'p-4',
    start: '2025-09-01T00:00:00',
    end: '2025-09-02T00:00:00',
    title: 'Labor Day',
    resource: 'personal',
    allDay: true,
    readOnly: true,
  },
  {
    id: 'w-22',
    start: '2025-09-02T09:30:00',
    end: '2025-09-02T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-18',
    start: '2025-09-02T18:00:00',
    end: '2025-09-02T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-23',
    start: '2025-09-03T10:00:00',
    end: '2025-09-03T11:00:00',
    title: '1-on-1 with James',
    resource: 'work',
  },
  {
    id: 'h-19',
    start: '2025-09-04T07:00:00',
    end: '2025-09-04T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 's-9',
    start: '2025-09-05T19:00:00',
    end: '2025-09-05T21:00:00',
    title: 'Book Club',
    resource: 'social',
  },
  {
    id: 'h-20',
    start: '2025-09-07T09:00:00',
    end: '2025-09-07T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Sep 8 – Sep 14
  {
    id: 'w-24',
    start: '2025-09-08T10:00:00',
    end: '2025-09-08T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'h-21',
    start: '2025-09-09T15:00:00',
    end: '2025-09-09T16:00:00',
    title: 'Dentist Checkup',
    resource: 'health',
  },
  {
    id: 't-2',
    start: '2025-09-10T00:00:00',
    end: '2025-09-13T00:00:00',
    title: 'Tech Conference',
    resource: 'travel',
    allDay: true,
    readOnly: true,
  },
  {
    id: 'f-5',
    start: '2025-09-14T11:00:00',
    end: '2025-09-14T13:00:00',
    title: 'Brunch with Parents',
    resource: 'family',
  },
  // Week of Sep 15 – Sep 21
  {
    id: 'w-25',
    start: '2025-09-15T09:30:00',
    end: '2025-09-15T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-22',
    start: '2025-09-15T07:00:00',
    end: '2025-09-15T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-26',
    start: '2025-09-16T14:00:00',
    end: '2025-09-16T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'h-23',
    start: '2025-09-17T07:00:00',
    end: '2025-09-17T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'w-27',
    start: '2025-09-18T14:00:00',
    end: '2025-09-18T15:30:00',
    title: 'Presentation',
    resource: 'work',
  },
  {
    id: 's-10',
    start: '2025-09-19T17:30:00',
    end: '2025-09-19T19:30:00',
    title: 'Happy Hour',
    resource: 'social',
  },
  {
    id: 'p-5',
    start: '2025-09-20T09:00:00',
    end: '2025-09-20T11:00:00',
    title: 'Car Service',
    resource: 'personal',
  },
  // Week of Sep 22 – Sep 28
  {
    id: 'h-24',
    start: '2025-09-22T07:00:00',
    end: '2025-09-22T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-28',
    start: '2025-09-22T15:00:00',
    end: '2025-09-22T16:00:00',
    title: 'All-hands Meeting',
    resource: 'work',
  },
  {
    id: 'h-25',
    start: '2025-09-23T18:00:00',
    end: '2025-09-23T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-29',
    start: '2025-09-24T10:00:00',
    end: '2025-09-24T11:30:00',
    title: 'Code Review',
    resource: 'work',
  },
  {
    id: 'w-30',
    start: '2025-09-25T16:00:00',
    end: '2025-09-25T17:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 's-11',
    start: '2025-09-27T18:00:00',
    end: '2025-09-27T22:00:00',
    title: 'Housewarming Party',
    resource: 'social',
    readOnly: true,
  },
  {
    id: 'h-26',
    start: '2025-09-28T09:00:00',
    end: '2025-09-28T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Sep 29 – Sep 30
  {
    id: 'w-31',
    start: '2025-09-29T09:30:00',
    end: '2025-09-29T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'w-32',
    start: '2025-09-30T14:00:00',
    end: '2025-09-30T16:00:00',
    title: 'Quarterly Review',
    resource: 'work',
  },
  // =====================
  // OCTOBER 2025
  // =====================

  // Week of Oct 1 – Oct 5
  {
    id: 'w-33',
    start: '2025-10-01T10:00:00',
    end: '2025-10-01T11:00:00',
    title: '1-on-1 with Sarah',
    resource: 'work',
  },
  {
    id: 'h-27',
    start: '2025-10-01T07:00:00',
    end: '2025-10-01T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'w-34',
    start: '2025-10-02T10:00:00',
    end: '2025-10-02T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'h-28',
    start: '2025-10-03T18:00:00',
    end: '2025-10-03T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'f-6',
    start: '2025-10-05T18:00:00',
    end: '2025-10-05T20:00:00',
    title: 'Family Dinner',
    resource: 'family',
  },
  // Week of Oct 6 – Oct 12
  {
    id: 'w-35',
    start: '2025-10-06T09:30:00',
    end: '2025-10-06T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-29',
    start: '2025-10-06T07:00:00',
    end: '2025-10-06T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-36',
    start: '2025-10-07T14:00:00',
    end: '2025-10-07T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'h-30',
    start: '2025-10-08T10:00:00',
    end: '2025-10-08T10:30:00',
    title: 'Flu Shot',
    resource: 'health',
  },
  {
    id: 'w-37',
    start: '2025-10-09T14:00:00',
    end: '2025-10-09T16:00:00',
    title: 'Design Review',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 's-12',
    start: '2025-10-11T20:00:00',
    end: '2025-10-11T23:00:00',
    title: 'Concert',
    resource: 'social',
  },
  // Week of Oct 13 – Oct 19
  {
    id: 'h-31',
    start: '2025-10-13T07:00:00',
    end: '2025-10-13T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-38',
    start: '2025-10-14T10:00:00',
    end: '2025-10-14T11:00:00',
    title: '1-on-1 with James',
    resource: 'work',
  },
  {
    id: 'h-32',
    start: '2025-10-14T18:00:00',
    end: '2025-10-14T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-39',
    start: '2025-10-15T15:00:00',
    end: '2025-10-15T16:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'w-40',
    start: '2025-10-16T14:00:00',
    end: '2025-10-16T15:00:00',
    title: 'Presentation',
    resource: 'work',
  },
  {
    id: 's-13',
    start: '2025-10-17T19:30:00',
    end: '2025-10-17T22:00:00',
    title: 'Dinner with Friends',
    resource: 'social',
    readOnly: true,
  },
  {
    id: 'h-33',
    start: '2025-10-19T09:00:00',
    end: '2025-10-19T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Oct 20 – Oct 26
  {
    id: 'w-41',
    start: '2025-10-20T09:30:00',
    end: '2025-10-20T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-34',
    start: '2025-10-21T18:00:00',
    end: '2025-10-21T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-42',
    start: '2025-10-22T10:00:00',
    end: '2025-10-22T12:00:00',
    title: 'Roadmap Planning',
    resource: 'work',
  },
  {
    id: 'h-35',
    start: '2025-10-23T16:00:00',
    end: '2025-10-23T17:00:00',
    title: 'Physical Therapy',
    resource: 'health',
  },
  {
    id: 's-14',
    start: '2025-10-25T19:00:00',
    end: '2025-10-25T23:00:00',
    title: 'Halloween Party',
    resource: 'social',
  },
  {
    id: 'p-6',
    start: '2025-10-25T10:00:00',
    end: '2025-10-25T11:30:00',
    title: 'Grocery Shopping',
    resource: 'personal',
  },
  // Week of Oct 27 – Oct 31
  {
    id: 'h-36',
    start: '2025-10-27T07:00:00',
    end: '2025-10-27T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-43',
    start: '2025-10-27T10:00:00',
    end: '2025-10-27T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'w-44',
    start: '2025-10-29T10:00:00',
    end: '2025-10-29T11:30:00',
    title: 'Code Review',
    resource: 'work',
  },
  // =====================
  // NOVEMBER 2025
  // =====================

  // Week of Nov 1 – Nov 2
  {
    id: 's-15',
    start: '2025-11-01T11:00:00',
    end: '2025-11-01T13:00:00',
    title: 'Brunch with Friends',
    resource: 'social',
  },
  {
    id: 'h-37',
    start: '2025-11-02T09:00:00',
    end: '2025-11-02T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Nov 3 – Nov 9
  {
    id: 'w-45',
    start: '2025-11-03T09:30:00',
    end: '2025-11-03T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-38',
    start: '2025-11-03T07:00:00',
    end: '2025-11-03T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-46',
    start: '2025-11-04T14:00:00',
    end: '2025-11-04T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'w-47',
    start: '2025-11-05T10:00:00',
    end: '2025-11-05T11:00:00',
    title: '1-on-1 with Sarah',
    resource: 'work',
  },
  {
    id: 'h-39',
    start: '2025-11-06T18:00:00',
    end: '2025-11-06T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'p-7',
    start: '2025-11-08T09:00:00',
    end: '2025-11-08T12:00:00',
    title: 'Home Repair (Plumber)',
    resource: 'personal',
  },
  // Week of Nov 10 – Nov 16
  {
    id: 'w-48',
    start: '2025-11-10T10:00:00',
    end: '2025-11-10T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'h-40',
    start: '2025-11-12T07:00:00',
    end: '2025-11-12T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'w-49',
    start: '2025-11-12T14:00:00',
    end: '2025-11-12T16:00:00',
    title: 'Design Review',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 'w-50',
    start: '2025-11-13T16:00:00',
    end: '2025-11-13T17:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 's-16',
    start: '2025-11-14T20:00:00',
    end: '2025-11-14T22:30:00',
    title: 'Movie Night',
    resource: 'social',
  },
  {
    id: 'f-7',
    start: '2025-11-16T11:00:00',
    end: '2025-11-16T13:00:00',
    title: 'Brunch with Parents',
    resource: 'family',
  },
  // Week of Nov 17 – Nov 23
  {
    id: 'w-51',
    start: '2025-11-17T09:30:00',
    end: '2025-11-17T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-41',
    start: '2025-11-17T07:00:00',
    end: '2025-11-17T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-52',
    start: '2025-11-18T14:00:00',
    end: '2025-11-18T15:00:00',
    title: 'Performance Review',
    resource: 'work',
  },
  {
    id: 'h-42',
    start: '2025-11-19T18:00:00',
    end: '2025-11-19T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-53',
    start: '2025-11-20T14:00:00',
    end: '2025-11-20T15:30:00',
    title: 'Presentation',
    resource: 'work',
  },
  {
    id: 'f-8',
    start: '2025-11-22T00:00:00',
    end: '2025-11-23T00:00:00',
    title: "Richard's Birthday",
    resource: 'family',
    allDay: true,
    readOnly: true,
  },
  {
    id: 'f-9',
    start: '2025-11-23T18:00:00',
    end: '2025-11-23T20:00:00',
    title: 'Family Dinner',
    resource: 'family',
  },
  // Week of Nov 24 – Nov 30 — Thanksgiving
  {
    id: 'w-54',
    start: '2025-11-24T10:00:00',
    end: '2025-11-24T10:30:00',
    title: 'Wrap-up Meeting',
    resource: 'work',
  },
  {
    id: 'p-8',
    start: '2025-11-25T14:00:00',
    end: '2025-11-25T16:00:00',
    title: 'Grocery Shopping',
    resource: 'personal',
  },
  {
    id: 'f-10',
    start: '2025-11-27T14:00:00',
    end: '2025-11-27T19:00:00',
    title: 'Thanksgiving Dinner',
    resource: 'family',
    readOnly: true,
  },
  {
    id: 'p-9',
    start: '2025-11-28T10:00:00',
    end: '2025-11-28T14:00:00',
    title: 'Black Friday Shopping',
    resource: 'personal',
  },
  {
    id: 'h-43',
    start: '2025-11-30T09:00:00',
    end: '2025-11-30T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // =====================
  // DECEMBER 2025
  // =====================

  // Week of Dec 1 – Dec 7
  {
    id: 'w-55',
    start: '2025-12-01T09:30:00',
    end: '2025-12-01T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-44',
    start: '2025-12-01T07:00:00',
    end: '2025-12-01T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-56',
    start: '2025-12-02T14:00:00',
    end: '2025-12-02T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'w-57',
    start: '2025-12-03T10:00:00',
    end: '2025-12-03T11:00:00',
    title: '1-on-1 with James',
    resource: 'work',
  },
  {
    id: 'h-45',
    start: '2025-12-04T18:00:00',
    end: '2025-12-04T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'p-10',
    start: '2025-12-06T13:00:00',
    end: '2025-12-06T17:00:00',
    title: 'Holiday Shopping',
    resource: 'personal',
  },
  // Week of Dec 8 – Dec 14
  {
    id: 'w-58',
    start: '2025-12-08T10:00:00',
    end: '2025-12-08T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'h-46',
    start: '2025-12-09T07:00:00',
    end: '2025-12-09T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'w-59',
    start: '2025-12-10T14:00:00',
    end: '2025-12-10T16:00:00',
    title: 'Year-end Review',
    resource: 'work',
  },
  {
    id: 's-17',
    start: '2025-12-11T18:00:00',
    end: '2025-12-11T22:00:00',
    title: 'Holiday Party',
    resource: 'social',
  },
  {
    id: 'p-11',
    start: '2025-12-13T14:00:00',
    end: '2025-12-13T16:00:00',
    title: 'Gift Wrapping',
    resource: 'personal',
  },
  {
    id: 'f-11',
    start: '2025-12-14T11:00:00',
    end: '2025-12-14T13:00:00',
    title: 'Brunch with Parents',
    resource: 'family',
  },
  // Week of Dec 15 – Dec 21
  {
    id: 'w-60',
    start: '2025-12-15T09:30:00',
    end: '2025-12-15T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-47',
    start: '2025-12-15T07:00:00',
    end: '2025-12-15T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-61',
    start: '2025-12-16T15:00:00',
    end: '2025-12-16T16:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 's-18',
    start: '2025-12-17T19:30:00',
    end: '2025-12-17T22:00:00',
    title: 'Dinner with Friends',
    resource: 'social',
    readOnly: true,
  },
  {
    id: 'w-62',
    start: '2025-12-19T10:00:00',
    end: '2025-12-19T11:00:00',
    title: 'Last Day Wrap-up',
    resource: 'work',
  },
  {
    id: 'f-12',
    start: '2025-12-21T18:00:00',
    end: '2025-12-21T20:00:00',
    title: 'Family Dinner',
    resource: 'family',
  },
  // Week of Dec 22 – Dec 28 — Holiday vacation
  {
    id: 't-3',
    start: '2025-12-22T00:00:00',
    end: '2025-12-29T00:00:00',
    title: 'Holiday Trip',
    resource: 'travel',
    allDay: true,
  },
  {
    id: 'f-13',
    start: '2025-12-25T00:00:00',
    end: '2025-12-26T00:00:00',
    title: 'Christmas',
    resource: 'family',
    allDay: true,
    readOnly: true,
  },
  // Week of Dec 29 – Dec 31
  {
    id: 'h-48',
    start: '2025-12-29T07:00:00',
    end: '2025-12-29T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'p-12',
    start: '2025-12-30T14:00:00',
    end: '2025-12-30T16:00:00',
    title: "New Year's Eve Prep",
    resource: 'personal',
  },
  {
    id: 's-19',
    start: '2025-12-31T20:00:00',
    end: '2025-12-31T23:59:00',
    title: "New Year's Eve Party",
    resource: 'social',
  },
  // =====================
  // JANUARY 2026
  // =====================

  // Week of Jan 1 – Jan 4
  {
    id: 'p-13',
    start: '2026-01-01T00:00:00',
    end: '2026-01-02T00:00:00',
    title: "New Year's Day",
    resource: 'personal',
    allDay: true,
    readOnly: true,
  },
  {
    id: 'h-49',
    start: '2026-01-02T07:00:00',
    end: '2026-01-02T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'h-50',
    start: '2026-01-04T09:00:00',
    end: '2026-01-04T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Jan 5 – Jan 11
  {
    id: 'w-63',
    start: '2026-01-05T09:30:00',
    end: '2026-01-05T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-51',
    start: '2026-01-05T07:00:00',
    end: '2026-01-05T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-64',
    start: '2026-01-06T14:00:00',
    end: '2026-01-06T15:30:00',
    title: 'Project Kickoff',
    resource: 'work',
  },
  {
    id: 'h-52',
    start: '2026-01-07T07:00:00',
    end: '2026-01-07T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'h-53',
    start: '2026-01-08T10:00:00',
    end: '2026-01-08T11:30:00',
    title: 'Annual Physical',
    resource: 'health',
  },
  {
    id: 's-20',
    start: '2026-01-09T17:30:00',
    end: '2026-01-09T19:30:00',
    title: 'Happy Hour',
    resource: 'social',
  },
  // Week of Jan 12 – Jan 18
  {
    id: 'w-65',
    start: '2026-01-12T10:00:00',
    end: '2026-01-12T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'w-66',
    start: '2026-01-13T14:00:00',
    end: '2026-01-13T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'h-54',
    start: '2026-01-13T18:00:00',
    end: '2026-01-13T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-67',
    start: '2026-01-14T10:00:00',
    end: '2026-01-14T11:00:00',
    title: '1-on-1 with Sarah',
    resource: 'work',
  },
  {
    id: 'h-55',
    start: '2026-01-15T07:00:00',
    end: '2026-01-15T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 's-21',
    start: '2026-01-17T19:00:00',
    end: '2026-01-17T23:00:00',
    title: 'Game Night',
    resource: 'social',
  },
  {
    id: 'f-14',
    start: '2026-01-18T11:00:00',
    end: '2026-01-18T13:00:00',
    title: 'Brunch with Parents',
    resource: 'family',
  },
  // Week of Jan 19 – Jan 25
  {
    id: 'p-14',
    start: '2026-01-19T00:00:00',
    end: '2026-01-20T00:00:00',
    title: 'Martin Luther King Jr. Day',
    resource: 'personal',
    allDay: true,
    readOnly: true,
  },
  {
    id: 'w-68',
    start: '2026-01-20T09:30:00',
    end: '2026-01-20T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'w-69',
    start: '2026-01-21T14:00:00',
    end: '2026-01-21T16:00:00',
    title: 'Design Review',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 'h-56',
    start: '2026-01-22T18:00:00',
    end: '2026-01-22T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 's-22',
    start: '2026-01-23T19:30:00',
    end: '2026-01-23T22:00:00',
    title: 'Dinner with Friends',
    resource: 'social',
    readOnly: true,
  },
  {
    id: 'p-15',
    start: '2026-01-24T10:00:00',
    end: '2026-01-24T11:30:00',
    title: 'Grocery Shopping',
    resource: 'personal',
  },
  // Week of Jan 26 – Jan 31
  {
    id: 'h-57',
    start: '2026-01-26T07:00:00',
    end: '2026-01-26T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-70',
    start: '2026-01-26T15:00:00',
    end: '2026-01-26T16:00:00',
    title: 'All-hands Meeting',
    resource: 'work',
  },
  {
    id: 'w-71',
    start: '2026-01-27T16:00:00',
    end: '2026-01-27T17:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'h-58',
    start: '2026-01-28T07:00:00',
    end: '2026-01-28T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'f-15',
    start: '2026-01-29T00:00:00',
    end: '2026-01-30T00:00:00',
    title: "Sarah's Birthday",
    resource: 'family',
    allDay: true,
    readOnly: true,
  },
  {
    id: 'p-16',
    start: '2026-01-31T09:00:00',
    end: '2026-01-31T12:00:00',
    title: 'Home Repair',
    resource: 'personal',
  },
  // =====================
  // FEBRUARY 2026
  // =====================

  // Week of Feb 1
  {
    id: 'h-59',
    start: '2026-02-01T09:00:00',
    end: '2026-02-01T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Feb 2 – Feb 8
  {
    id: 'w-72',
    start: '2026-02-02T09:30:00',
    end: '2026-02-02T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-60',
    start: '2026-02-02T07:00:00',
    end: '2026-02-02T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'h-61',
    start: '2026-02-03T18:00:00',
    end: '2026-02-03T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-73',
    start: '2026-02-04T10:00:00',
    end: '2026-02-04T11:00:00',
    title: '1-on-1 with James',
    resource: 'work',
  },
  {
    id: 'w-74',
    start: '2026-02-05T10:00:00',
    end: '2026-02-05T11:30:00',
    title: 'Code Review',
    resource: 'work',
  },
  {
    id: 's-23',
    start: '2026-02-07T20:00:00',
    end: '2026-02-07T22:30:00',
    title: 'Movie Night',
    resource: 'social',
  },
  // Week of Feb 9 – Feb 15
  {
    id: 'w-75',
    start: '2026-02-09T10:00:00',
    end: '2026-02-09T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'w-76',
    start: '2026-02-10T14:00:00',
    end: '2026-02-10T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'h-62',
    start: '2026-02-11T07:00:00',
    end: '2026-02-11T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'h-63',
    start: '2026-02-12T18:00:00',
    end: '2026-02-12T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 's-24',
    start: '2026-02-14T19:00:00',
    end: '2026-02-14T22:00:00',
    title: "Valentine's Dinner",
    resource: 'social',
  },
  {
    id: 'f-16',
    start: '2026-02-15T11:00:00',
    end: '2026-02-15T13:00:00',
    title: 'Brunch with Parents',
    resource: 'family',
  },
  // Week of Feb 16 – Feb 22
  {
    id: 'w-77',
    start: '2026-02-17T09:30:00',
    end: '2026-02-17T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-64',
    start: '2026-02-17T07:00:00',
    end: '2026-02-17T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-78',
    start: '2026-02-18T14:00:00',
    end: '2026-02-18T16:00:00',
    title: 'Design Review',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 'w-79',
    start: '2026-02-19T15:00:00',
    end: '2026-02-19T16:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 's-25',
    start: '2026-02-20T19:00:00',
    end: '2026-02-20T21:00:00',
    title: 'Book Club',
    resource: 'social',
  },
  {
    id: 'p-17',
    start: '2026-02-21T11:00:00',
    end: '2026-02-21T12:00:00',
    title: 'Haircut',
    resource: 'personal',
  },
  // Week of Feb 23 – Feb 28
  {
    id: 'h-65',
    start: '2026-02-23T07:00:00',
    end: '2026-02-23T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-80',
    start: '2026-02-23T15:00:00',
    end: '2026-02-23T16:00:00',
    title: 'All-hands Meeting',
    resource: 'work',
  },
  {
    id: 'h-66',
    start: '2026-02-24T18:00:00',
    end: '2026-02-24T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-81',
    start: '2026-02-25T10:00:00',
    end: '2026-02-25T11:00:00',
    title: '1-on-1 with Sarah',
    resource: 'work',
  },
  {
    id: 's-26',
    start: '2026-02-26T19:30:00',
    end: '2026-02-26T22:00:00',
    title: 'Dinner with Friends',
    resource: 'social',
    readOnly: true,
  },
  {
    id: 'f-17',
    start: '2026-02-28T00:00:00',
    end: '2026-03-01T00:00:00',
    title: "Mark's Birthday",
    resource: 'family',
    allDay: true,
    readOnly: true,
  },
  // =====================
  // MARCH 2026
  // =====================

  // Week of Mar 1
  {
    id: 'h-67',
    start: '2026-03-01T09:00:00',
    end: '2026-03-01T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Mar 2 – Mar 8
  {
    id: 'w-82',
    start: '2026-03-02T09:30:00',
    end: '2026-03-02T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-68',
    start: '2026-03-02T07:00:00',
    end: '2026-03-02T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-83',
    start: '2026-03-03T14:00:00',
    end: '2026-03-03T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'h-69',
    start: '2026-03-04T07:00:00',
    end: '2026-03-04T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'w-84',
    start: '2026-03-05T10:00:00',
    end: '2026-03-05T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 's-27',
    start: '2026-03-06T17:30:00',
    end: '2026-03-06T19:30:00',
    title: 'Happy Hour',
    resource: 'social',
  },
  // Week of Mar 9 – Mar 15
  {
    id: 'h-70',
    start: '2026-03-09T07:00:00',
    end: '2026-03-09T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-85',
    start: '2026-03-10T10:00:00',
    end: '2026-03-10T11:00:00',
    title: '1-on-1 with James',
    resource: 'work',
  },
  {
    id: 'h-71',
    start: '2026-03-10T18:00:00',
    end: '2026-03-10T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-86',
    start: '2026-03-11T16:00:00',
    end: '2026-03-11T17:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'p-18',
    start: '2026-03-12T14:00:00',
    end: '2026-03-12T15:30:00',
    title: 'Tax Prep Appointment',
    resource: 'personal',
  },
  {
    id: 'p-19',
    start: '2026-03-14T09:00:00',
    end: '2026-03-14T13:00:00',
    title: 'Spring Cleaning',
    resource: 'personal',
  },
  {
    id: 'f-18',
    start: '2026-03-15T18:00:00',
    end: '2026-03-15T20:00:00',
    title: 'Family Dinner',
    resource: 'family',
  },
  // Week of Mar 16 – Mar 22
  {
    id: 'w-87',
    start: '2026-03-16T09:30:00',
    end: '2026-03-16T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'w-88',
    start: '2026-03-17T14:00:00',
    end: '2026-03-17T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'w-89',
    start: '2026-03-18T14:00:00',
    end: '2026-03-18T16:00:00',
    title: 'Design Review',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 'h-72',
    start: '2026-03-19T18:00:00',
    end: '2026-03-19T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 's-28',
    start: '2026-03-20T20:00:00',
    end: '2026-03-20T23:00:00',
    title: 'Concert',
    resource: 'social',
  },
  {
    id: 'f-19',
    start: '2026-03-22T11:00:00',
    end: '2026-03-22T13:00:00',
    title: 'Brunch with Parents',
    resource: 'family',
  },
  // Week of Mar 23 – Mar 29
  {
    id: 'h-73',
    start: '2026-03-23T07:00:00',
    end: '2026-03-23T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-90',
    start: '2026-03-23T10:00:00',
    end: '2026-03-23T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'w-91',
    start: '2026-03-24T14:00:00',
    end: '2026-03-24T15:30:00',
    title: 'Presentation',
    resource: 'work',
  },
  {
    id: 'h-74',
    start: '2026-03-25T07:00:00',
    end: '2026-03-25T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 's-29',
    start: '2026-03-26T19:30:00',
    end: '2026-03-26T22:00:00',
    title: 'Dinner with Friends',
    resource: 'social',
    readOnly: true,
  },
  {
    id: 'p-20',
    start: '2026-03-28T10:00:00',
    end: '2026-03-28T11:30:00',
    title: 'Grocery Shopping',
    resource: 'personal',
  },
  {
    id: 'h-75',
    start: '2026-03-29T09:00:00',
    end: '2026-03-29T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Mar 30 – Mar 31
  {
    id: 'w-92',
    start: '2026-03-30T09:30:00',
    end: '2026-03-30T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'w-93',
    start: '2026-03-31T14:00:00',
    end: '2026-03-31T16:00:00',
    title: 'Quarterly Review',
    resource: 'work',
  },
  // =====================
  // APRIL 2026
  // =====================

  // Week of Apr 1 – Apr 5
  {
    id: 'w-94',
    start: '2026-04-01T10:00:00',
    end: '2026-04-01T11:00:00',
    title: '1-on-1 with Sarah',
    resource: 'work',
  },
  {
    id: 'h-76',
    start: '2026-04-01T07:00:00',
    end: '2026-04-01T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'w-95',
    start: '2026-04-02T10:00:00',
    end: '2026-04-02T11:30:00',
    title: 'Code Review',
    resource: 'work',
  },
  {
    id: 'h-77',
    start: '2026-04-03T14:00:00',
    end: '2026-04-03T15:00:00',
    title: 'Eye Exam',
    resource: 'health',
  },
  {
    id: 'f-20',
    start: '2026-04-05T11:00:00',
    end: '2026-04-05T14:00:00',
    title: 'Easter Brunch',
    resource: 'family',
    readOnly: true,
  },
  // Week of Apr 6 – Apr 12
  {
    id: 'w-96',
    start: '2026-04-06T09:30:00',
    end: '2026-04-06T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-78',
    start: '2026-04-06T07:00:00',
    end: '2026-04-06T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-97',
    start: '2026-04-07T14:00:00',
    end: '2026-04-07T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'h-79',
    start: '2026-04-08T18:00:00',
    end: '2026-04-08T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-98',
    start: '2026-04-09T10:00:00',
    end: '2026-04-09T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 's-30',
    start: '2026-04-11T19:30:00',
    end: '2026-04-11T22:00:00',
    title: 'Dinner with Friends',
    resource: 'social',
    readOnly: true,
  },
  // Week of Apr 13 – Apr 19
  {
    id: 'h-80',
    start: '2026-04-13T07:00:00',
    end: '2026-04-13T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-99',
    start: '2026-04-14T10:00:00',
    end: '2026-04-14T11:00:00',
    title: '1-on-1 with James',
    resource: 'work',
  },
  {
    id: 'h-81',
    start: '2026-04-14T18:00:00',
    end: '2026-04-14T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-100',
    start: '2026-04-15T15:00:00',
    end: '2026-04-15T16:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'w-101',
    start: '2026-04-16T14:00:00',
    end: '2026-04-16T15:00:00',
    title: 'Presentation',
    resource: 'work',
  },
  {
    id: 's-31',
    start: '2026-04-17T20:00:00',
    end: '2026-04-17T22:30:00',
    title: 'Movie Night',
    resource: 'social',
  },
  {
    id: 'h-82',
    start: '2026-04-19T09:00:00',
    end: '2026-04-19T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Apr 20 – Apr 26
  {
    id: 'w-102',
    start: '2026-04-20T09:30:00',
    end: '2026-04-20T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'w-103',
    start: '2026-04-21T14:00:00',
    end: '2026-04-21T16:00:00',
    title: 'Design Review',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 'h-83',
    start: '2026-04-22T07:00:00',
    end: '2026-04-22T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'h-84',
    start: '2026-04-23T16:00:00',
    end: '2026-04-23T17:00:00',
    title: 'Physical Therapy',
    resource: 'health',
  },
  {
    id: 'f-21',
    start: '2026-04-25T10:00:00',
    end: '2026-04-25T12:00:00',
    title: "Nephew's Soccer Game",
    resource: 'family',
  },
  {
    id: 's-32',
    start: '2026-04-25T17:30:00',
    end: '2026-04-25T19:30:00',
    title: 'Happy Hour',
    resource: 'social',
  },
  // Week of Apr 27 – Apr 30
  {
    id: 'h-85',
    start: '2026-04-27T07:00:00',
    end: '2026-04-27T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-104',
    start: '2026-04-27T10:00:00',
    end: '2026-04-27T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'w-105',
    start: '2026-04-28T14:00:00',
    end: '2026-04-28T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'h-86',
    start: '2026-04-29T18:00:00',
    end: '2026-04-29T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-106',
    start: '2026-04-30T15:00:00',
    end: '2026-04-30T16:00:00',
    title: 'All-hands Meeting',
    resource: 'work',
  },
  // =====================
  // MAY 2026
  // =====================

  // Week of May 1 – May 3
  {
    id: 'w-107',
    start: '2026-05-01T10:00:00',
    end: '2026-05-01T10:30:00',
    title: 'Wrap-up Meeting',
    resource: 'work',
  },
  {
    id: 'p-21',
    start: '2026-05-02T10:00:00',
    end: '2026-05-02T11:30:00',
    title: 'Grocery Shopping',
    resource: 'personal',
  },
  {
    id: 'f-22',
    start: '2026-05-03T11:00:00',
    end: '2026-05-03T13:00:00',
    title: 'Brunch with Parents',
    resource: 'family',
  },
  // Week of May 4 – May 10
  {
    id: 'w-108',
    start: '2026-05-04T09:30:00',
    end: '2026-05-04T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-87',
    start: '2026-05-04T07:00:00',
    end: '2026-05-04T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-109',
    start: '2026-05-05T14:00:00',
    end: '2026-05-05T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'w-110',
    start: '2026-05-06T10:00:00',
    end: '2026-05-06T11:00:00',
    title: '1-on-1 with Sarah',
    resource: 'work',
  },
  {
    id: 'h-88',
    start: '2026-05-07T18:00:00',
    end: '2026-05-07T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 's-33',
    start: '2026-05-09T20:00:00',
    end: '2026-05-09T23:00:00',
    title: 'Concert',
    resource: 'social',
  },
  // Week of May 11 – May 17
  {
    id: 'w-111',
    start: '2026-05-11T10:00:00',
    end: '2026-05-11T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 'h-89',
    start: '2026-05-12T07:00:00',
    end: '2026-05-12T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'w-112',
    start: '2026-05-13T14:00:00',
    end: '2026-05-13T16:00:00',
    title: 'Design Review',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 'w-113',
    start: '2026-05-14T16:00:00',
    end: '2026-05-14T17:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 's-34',
    start: '2026-05-15T19:30:00',
    end: '2026-05-15T22:00:00',
    title: 'Dinner with Friends',
    resource: 'social',
    readOnly: true,
  },
  {
    id: 'h-90',
    start: '2026-05-17T09:00:00',
    end: '2026-05-17T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of May 18 – May 24
  {
    id: 'w-114',
    start: '2026-05-18T09:30:00',
    end: '2026-05-18T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-91',
    start: '2026-05-18T07:00:00',
    end: '2026-05-18T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'h-92',
    start: '2026-05-19T18:00:00',
    end: '2026-05-19T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-115',
    start: '2026-05-20T10:00:00',
    end: '2026-05-20T11:30:00',
    title: 'Code Review',
    resource: 'work',
  },
  {
    id: 'f-23',
    start: '2026-05-21T19:00:00',
    end: '2026-05-21T22:00:00',
    title: 'Anniversary Dinner',
    resource: 'family',
  },
  {
    id: 'p-22',
    start: '2026-05-23T09:00:00',
    end: '2026-05-23T12:00:00',
    title: 'Home Repair',
    resource: 'personal',
  },
  // Week of May 25 – May 31
  {
    id: 's-35',
    start: '2026-05-25T12:00:00',
    end: '2026-05-25T17:00:00',
    title: 'Memorial Day BBQ',
    resource: 'social',
  },
  {
    id: 'h-93',
    start: '2026-05-26T07:00:00',
    end: '2026-05-26T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-116',
    start: '2026-05-27T10:00:00',
    end: '2026-05-27T11:00:00',
    title: '1-on-1 with James',
    resource: 'work',
  },
  {
    id: 'w-117',
    start: '2026-05-28T14:00:00',
    end: '2026-05-28T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'f-24',
    start: '2026-05-29T00:00:00',
    end: '2026-05-30T00:00:00',
    title: "Tom's Birthday",
    resource: 'family',
    allDay: true,
    readOnly: true,
  },
  {
    id: 'f-25',
    start: '2026-05-31T18:00:00',
    end: '2026-05-31T20:00:00',
    title: 'Family Dinner',
    resource: 'family',
  },
  // =====================
  // JUNE 2026
  // =====================

  // Week of Jun 1 – Jun 7
  {
    id: 'w-118',
    start: '2026-06-01T09:30:00',
    end: '2026-06-01T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-94',
    start: '2026-06-01T07:00:00',
    end: '2026-06-01T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'h-95',
    start: '2026-06-02T18:00:00',
    end: '2026-06-02T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-119',
    start: '2026-06-03T14:00:00',
    end: '2026-06-03T16:00:00',
    title: 'Quarterly Review',
    resource: 'work',
  },
  {
    id: 'w-120',
    start: '2026-06-04T10:00:00',
    end: '2026-06-04T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
  {
    id: 's-36',
    start: '2026-06-06T19:30:00',
    end: '2026-06-06T22:00:00',
    title: 'Dinner with Friends',
    resource: 'social',
    readOnly: true,
  },
  {
    id: 'h-96',
    start: '2026-06-07T09:00:00',
    end: '2026-06-07T10:30:00',
    title: 'Long Run',
    resource: 'health',
  },
  // Week of Jun 8 – Jun 14
  {
    id: 'h-97',
    start: '2026-06-08T07:00:00',
    end: '2026-06-08T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 'w-121',
    start: '2026-06-09T14:00:00',
    end: '2026-06-09T15:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'w-122',
    start: '2026-06-10T10:00:00',
    end: '2026-06-10T11:00:00',
    title: '1-on-1 with Sarah',
    resource: 'work',
  },
  {
    id: 'w-123',
    start: '2026-06-11T14:00:00',
    end: '2026-06-11T15:30:00',
    title: 'Presentation',
    resource: 'work',
  },
  {
    id: 't-4',
    start: '2026-06-12T00:00:00',
    end: '2026-06-15T00:00:00',
    title: 'Weekend Getaway',
    resource: 'travel',
    allDay: true,
  },
  // Week of Jun 15 – Jun 21
  {
    id: 'w-124',
    start: '2026-06-15T09:30:00',
    end: '2026-06-15T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-98',
    start: '2026-06-15T07:00:00',
    end: '2026-06-15T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-125',
    start: '2026-06-16T15:00:00',
    end: '2026-06-16T16:00:00',
    title: 'Client Call',
    resource: 'work',
  },
  {
    id: 'w-126',
    start: '2026-06-17T14:00:00',
    end: '2026-06-17T16:00:00',
    title: 'Design Review',
    resource: 'work',
    readOnly: true,
  },
  {
    id: 'h-99',
    start: '2026-06-18T18:00:00',
    end: '2026-06-18T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'p-23',
    start: '2026-06-20T09:00:00',
    end: '2026-06-20T11:00:00',
    title: 'Car Service',
    resource: 'personal',
  },
  // Week of Jun 22 – Jun 28
  {
    id: 'h-100',
    start: '2026-06-22T07:00:00',
    end: '2026-06-22T07:45:00',
    title: 'Morning Run',
    resource: 'health',
  },
  {
    id: 'w-127',
    start: '2026-06-23T10:00:00',
    end: '2026-06-23T11:00:00',
    title: '1-on-1 with James',
    resource: 'work',
  },
  {
    id: 'h-101',
    start: '2026-06-24T07:00:00',
    end: '2026-06-24T08:00:00',
    title: 'Yoga',
    resource: 'health',
  },
  {
    id: 't-5',
    start: '2026-06-26T00:00:00',
    end: '2026-06-29T00:00:00',
    title: 'Wedding Weekend',
    resource: 'travel',
    allDay: true,
    readOnly: true,
  },
  // Week of Jun 29 – Jun 30
  {
    id: 'w-128',
    start: '2026-06-29T09:30:00',
    end: '2026-06-29T10:30:00',
    title: 'Team Meeting',
    resource: 'work',
  },
  {
    id: 'h-102',
    start: '2026-06-29T18:00:00',
    end: '2026-06-29T19:00:00',
    title: 'Gym Class',
    resource: 'health',
  },
  {
    id: 'w-129',
    start: '2026-06-30T10:00:00',
    end: '2026-06-30T11:30:00',
    title: 'Sprint Planning',
    resource: 'work',
  },
];

export const resources = [
  { title: 'Work', id: 'work', eventColor: 'purple' },
  { title: 'Health', id: 'health', eventColor: 'teal' },
  { title: 'Social', id: 'social', eventColor: 'orange' },
  { title: 'Personal', id: 'personal', eventColor: 'lime' },
  { title: 'Travel', id: 'travel', eventColor: 'blue' },
  { title: 'Family', id: 'family', eventColor: 'pink' },
];
